import { PropertySimilar } from "@shared-ui/lodging-property-details";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";

export const PropertySimilarProperties = PropertyBexApiWrapper(PropertySimilar);
export default PropertySimilarProperties;
